import { Team } from './team.model';

export class TeamCommand {
    name: string;
    parent: {
        id: string;
    } | null;

    constructor(tempTeam: Team) {
        this.name = tempTeam.name;
        this.parent = tempTeam.parent ? { id: tempTeam.parent.id } : null;
    }
}
